var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 64,
    viewBox: "0 0 81 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_21767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3418 63.8588H24.6338V58.4883H29.2322V59.7412H26.483V60.5088H28.81V61.7617H26.483V62.6044H29.3418V63.8573V63.8588Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9679 58.4883L33.9809 61.4192L33.9103 60.1963V58.4883H35.6799V63.8588H33.9493L31.9363 60.9355L32.0069 62.1583V63.8588H30.2373V58.4883H31.9679Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5196 63.8588H36.8115V58.4883H41.4099V59.7412H38.6608V60.5088H40.9878V61.7617H38.6608V62.6044H41.5196V63.8573V63.8588Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7622 61.987H44.1989V63.8588H42.3496V58.4883H45.0131C45.9325 58.4883 46.5844 58.613 46.9705 58.8609C47.331 59.0952 47.5113 59.4798 47.5113 60.0176C47.5113 60.7281 47.1958 61.1668 46.5634 61.3305C46.9179 61.4552 47.1538 61.5844 47.2679 61.7181C47.4347 61.9164 47.5188 62.2619 47.5188 62.7547C47.5188 63.1723 47.5233 63.4157 47.5338 63.4863C47.5549 63.626 47.615 63.6951 47.7141 63.6951V63.8588H45.8423C45.7792 63.6996 45.7477 63.3871 45.7477 62.9184C45.7477 62.5504 45.6906 62.307 45.5749 62.1868C45.4442 62.0531 45.1723 61.9855 44.7607 61.9855L44.7622 61.987ZM44.1989 59.7412V60.8078H44.9275C45.5118 60.8078 45.8048 60.638 45.8048 60.3C45.8048 59.9274 45.5569 59.7412 45.0612 59.7412H44.1989Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1874 61.5243H49.8324C49.8324 61.9029 49.8534 62.1658 49.8955 62.3145C49.9631 62.5639 50.1043 62.687 50.3176 62.687C50.6316 62.687 50.7878 62.4677 50.7878 62.0306V58.4868H52.6356V61.7842C52.6356 63.2609 51.9025 64 50.4348 64C48.9671 64 48.1709 63.3015 48.1709 61.9044C48.1709 61.7797 48.1754 61.6535 48.1859 61.5243H48.1874Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6349 63.8588H53.7871V58.4883H55.6349V63.8588ZM55.384 57.958H54.029V56.9875H55.384V57.958Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9779 49.3607H75.5718C76.0991 49.3607 76.4731 49.29 76.6954 49.1458C76.9283 49.0046 77.044 48.7327 77.044 48.3346C77.044 47.9155 76.9178 47.6301 76.6639 47.4768C76.4416 47.3537 76.0465 47.2936 75.4801 47.2936H73.9779V49.3622V49.3607ZM70.5152 55.6475V44.6211H75.7385C77.3369 44.6211 78.4861 44.8569 79.1847 45.3271C79.9223 45.8199 80.2933 46.6416 80.2933 47.7968C80.2933 49.1038 79.7059 50.0156 78.5327 50.5264C79.1396 50.6571 79.5798 50.9155 79.8532 51.294C80.1266 51.6726 80.2783 52.2329 80.3083 52.9811L80.3684 54.5133C80.3789 54.7898 80.394 54.964 80.4135 55.0376C80.454 55.1593 80.5457 55.2254 80.6869 55.2359V55.649H77.1491C77.0184 55.1097 76.9523 54.7252 76.9523 54.4998V53.3987C76.9523 52.8248 76.8412 52.4252 76.6188 52.2014C76.3965 51.9655 76.0119 51.8484 75.4651 51.8484H73.9779V55.649H70.5167L70.5152 55.6475ZM59.9349 55.6475V44.6211H68.6645V47.259H63.4427V48.7312H67.8608V51.261H63.4427V52.9645H68.8778V55.646H59.9364L59.9349 55.6475ZM50.2335 55.6475V44.6211H53.7397V52.7182H58.5078V55.646H50.2335V55.6475ZM38.3928 55.6475V44.6211H41.8705V48.2715L45.0117 44.6211H49.0797L45.1784 48.6861L49.5815 55.6475H45.4068L42.7343 51.2309L41.869 52.1353V55.6475H38.3913H38.3928ZM32.6843 55.6475V44.6211H36.2521V55.6475H32.6843ZM22.9242 55.6475V44.6211H26.4304V52.7182H31.1971V55.646H22.9227L22.9242 55.6475ZM12.3424 55.6475V44.6211H21.0719V47.259H15.8502V48.7312H20.2682V51.261H15.8502V52.9645H21.2853V55.646H12.3439L12.3424 55.6475ZM6.92684 55.8533L6.03601 57.8002L3.26287 57.7612L4.3535 55.8533C3.19677 55.655 2.24735 55.1743 1.50374 54.4067C0.501749 53.3626 0 51.943 0 50.1433C0 48.3436 0.49574 46.93 1.48722 45.895C2.48921 44.8539 3.84574 44.3326 5.55679 44.3326C7.13565 44.3326 8.375 44.7202 9.27484 45.4969C10.1867 46.266 10.6975 47.3657 10.8086 48.7928H7.45412C7.34296 47.6601 6.72554 47.0908 5.60186 47.0908C4.22581 47.0908 3.53778 48.1093 3.53778 50.1433C3.53778 52.1774 4.25585 53.1944 5.6935 53.1944C6.81717 53.1944 7.43459 52.5875 7.54576 51.3707H10.8702C10.7696 52.8233 10.2633 53.9545 9.35296 54.7612C8.70849 55.3246 7.90029 55.6881 6.92684 55.8548V55.8533Z",
    fill: "#19398A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11595 55.4388L6.03583 57.7988L3.2627 57.7612L4.68532 55.2705L7.11595 55.4388Z",
    fill: "#19398A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2524 41.8735H32.6846V43.8429H36.2524V41.8735Z",
    fill: "#19398A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9094 0.102158L52.317 0.462696L51.7356 8.59433L44.3115 8.12713L44.9094 0.102158Z",
    fill: "url(#paint0_linear_93_21767)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7163 25.9347C34.4975 26.9923 35.5115 27.9883 36.7524 28.9031C39.5225 30.9387 42.6066 31.9737 45.9191 31.9707C50.2155 31.9707 53.5625 30.2026 54.2174 29.83C53.0066 29.5341 47.3026 28.3623 47.3026 28.3623C47.3026 28.3623 38.7338 32.1735 33.7148 25.9347H33.7163Z",
    fill: "url(#paint1_linear_93_21767)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8137 17.752C28.0099 12.8051 31.9638 10.376 35.6609 9.20121C40.0639 7.72451 44.0374 8.13613 44.0374 8.13613L44.7209 0.138192C44.7209 0.138192 30.1687 -1.98748 24.4571 10.3955C20.1157 19.8055 23.9043 26.5656 26.0014 29.2411C23.9884 25.8701 23.9208 22.0108 25.8122 17.752H25.8137Z",
    fill: "url(#paint2_linear_93_21767)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9736 17.8241C21.6291 27.6142 28.4884 32.8585 34.0241 35.9547C36.6651 37.4299 40.5604 38.3132 44.4422 38.3132C47.2559 38.3132 49.9178 37.846 52.1412 36.9597C52.5167 36.0463 53.9288 31.1009 54.2353 30.0208C53.4256 30.47 50.1176 32.148 45.9174 32.148C42.5659 32.148 39.4472 31.1039 36.6455 29.0443C32.4903 25.9918 30.8334 22.0169 31.9811 17.8587C33.273 13.1747 37.9119 9.22377 43.0105 8.32393C42.9099 8.32393 42.8092 8.32393 42.7071 8.32393C38.944 8.32393 29.7788 9.24781 25.9736 17.8271V17.8241Z",
    fill: "url(#paint3_linear_93_21767)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_21767",
    x1: 43.5604,
    y1: 6.27186,
    x2: 53.1056,
    y2: 2.41561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929496"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_21767",
    x1: 34.0273,
    y1: 29.4905,
    x2: 54.0342,
    y2: 27.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_93_21767",
    x1: 20.7541,
    y1: 20.7399,
    x2: 47.458,
    y2: 4.69449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_93_21767",
    x1: 30.276,
    y1: 12.1231,
    x2: 48.1076,
    y2: 39.5796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8ABAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8A8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8C8E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_21767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.6869,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.d18a45bc3847cfbfe11745ed178e9c1d.svg";
export { ForwardRef as ReactComponent };